import { ApolloClient, InMemoryCache, HttpLink, ApolloLink, FetchPolicy } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import { handleTokenErrorAndRedirect } from 'utils/helperMethods';
import { ensureFreshToken } from 'services/tokenManager';

const setheader = setContext(async (request, previousContext) => {
    // Silently renews the token before the request when it is stale, so GraphQL
    // calls never go out with an expired token.
    const accessToken = await ensureFreshToken();
    return {
        headers: {
            authorization: `Bearer ${accessToken}`,
            //categoryName: `${localStorage.getItem('categoryName')}`,
        },
    };
});

const url = process.env.REACT_APP_ENDPOINT_URL + 'ppai/graphql/';

//const httpLink = new HttpLink({ uri: 'https://staging-promo.azure.dynamicdemand.ai/ppai/graphql/' });
const httpLink = new HttpLink({ uri: url });

function parseNetworkErrorBody(result: unknown): Record<string, unknown> {
    if (result == null) return {};
    if (typeof result === 'string') {
        try {
            return JSON.parse(result || '{}') as Record<string, unknown>;
        } catch {
            return {};
        }
    }
    if (typeof result === 'object') {
        return result as Record<string, unknown>;
    }
    return {};
}

// Create an error link to catch all errors
const errorLink = onError((error: any) => {
    const parsedError = {
        status: error?.networkError?.statusCode,
        message: error?.networkError?.result,
        ...parseNetworkErrorBody(error?.networkError?.result),
    };
    //condition to check if token is invalid
    //refresh page if token is invalid so that new token will be generated
    //this will redirect user to login page if session is expired
    handleTokenErrorAndRedirect(parsedError);
});

const link = ApolloLink.from([errorLink, setheader, httpLink]);

export const client = new ApolloClient({
    cache: new InMemoryCache(),
    link,
}) as any;

export const queryPromise = async (query: any, variables: any, fetchPolicy: FetchPolicy = 'cache-first') => {
    return await client.query({
        query,
        variables,
        fetchPolicy,
    });
};
